import { PrismicRichText } from '@prismicio/react';
import React from 'react';

import classes from './TermsOfService.module.css';
import type { Content } from '@prismicio/client';
import type { SliceComponentProps } from '@prismicio/react';

/**
 * Props for `TermsOfServiceSlice`.
 */
export type TermsOfServiceSliceProps =
  SliceComponentProps<Content.TermsOfServiceSliceSlice>;

/**
 * Component for "TermsOfServiceSlice" Slices.
 */
const TermsOfServiceSlice = ({
  slice,
}: TermsOfServiceSliceProps): JSX.Element => {
  return (
    // TODO: Figure out why tailwind prose class isn't working
    <div className={`flex flex-col space-y-4 text-black ${classes.prose}`}>
      <PrismicRichText field={slice.primary.tos} />
    </div>
  );
};

export default TermsOfServiceSlice;
